export default __webpack_public_path__ + "static/media/Completed@1.5x.9377f21b.svg";